export const timeoutSave = (timeoutTimer, setTimeoutTimer, onSave, timeout=1000) => {
    clearTimeout(timeoutTimer);
    const newTimer = setTimeout( onSave, timeout);
    setTimeoutTimer(newTimer);
};